import { MeResponseDTO } from "./me.dto";
import { FetchHttpFactory } from "../../http";

const fetchHttpFactory = new FetchHttpFactory();
const http = fetchHttpFactory.createHttp("/admin/me");

export const getMe = () => http.get<MeResponseDTO>("");
